enum StatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export default StatusEnum;
